<template>
    <v-container>
        <v-row dense align='center'>
            <v-col cols='3'>
                <v-row dense >
                    <v-icon
                        v-if='type.guidanceType == "good practice"'
                        color='secondary'
                        :large='large' 
                    >
                        mdi-chevron-left-circle-outline
                    </v-icon>
                    <v-icon
                        v-if='type.guidanceType == "baseline"'
                        color='tertiary'
                        :large='large'
                    >
                        mdi-record-circle-outline
                    </v-icon>
                    <v-icon
                        v-if='type.guidanceType == "worst case"'
                        color='error'
                        :large='large'
                    >
                        mdi-chevron-right-circle-outline
                    </v-icon>
                </v-row>
            </v-col>
            <v-col cols='9'>
                <v-row dense justify="end">
                    <v-chip 
                        color='secondary'
                        class='mx-1 my-1'
                        :small='small'
                    > 
                        {{ type.category }} | {{ type.subCategory }}
                    </v-chip>
                    <v-chip 
                        color='primary'
                        text-color='secondary'
                        class='mx-1 my-1'
                        :small='small'                               
                    > 
                        {{ type.primarymaterial }} 
                    </v-chip>
                    <v-chip 
                        color='tertiary'
                        class='mx-1 my-1'
                        dark
                        :small='small'
                    > 
                        {{ type.region }} 
                    </v-chip>

                </v-row>
                
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        type: Object,
        large: { type:Boolean, default:false },
        small: { type:Boolean, default:false }
    }
}
</script>